import { PopoverModes, PopoverPlacements, } from '../_lib/component/PopoverBase/type';
export var PopoverBadgeModes = PopoverModes;
export var PopoverBadgePlacements = PopoverPlacements;
